import React from 'react'
import imagen from '../Imagenes/logoKick.png';

export const Home = () => {

  const imagenes = [imagen];

  return (
    <>
      <div className='banner'>
        <div className='fondo-banner'></div>
        <h1>Bienvenido!</h1>
      </div>

      <div className='appear'>

        <article className='exp'>
          <div className='dividir'>

            <section className='exp'>
                  <center><h3>Explora</h3></center>
                  <div className='bloques'>

                    <div className='tarjeta n1'>
                      <div className='tarjeta-miniatura'>
                        <img alt='Proyecto VSRG logo' src={imagenes[0]} />
                      </div>
                      <article>
                        <h3 className='aviso'>Proyect VSRG</h3>
                        <p>Juego ritmico con <b>ranks</b> basado en <a href='https://es.wikipedia.org/wiki/Sistema_de_puntuaci%C3%B3n_Elo' target='_blank' rel='noreferrer'>Elo</a>, con bots, cooperativo y mucha personalización en desarrollo; Puedes probarlo y ayudar con el desarrollo entrando a nuestro servidor de <a href='https://discord.gg/US3JmB4RPH' target='_blank' rel="noreferrer">discord!</a></p>
                        <a href='/proyectos/ProyectVSRG' class='btn'>Ver mas <span class="material-symbols-outlined fixV owo">open_in_new</span></a>
                      </article>
                    </div>

                    <div className='tarjeta n2'>
                      <article>
                        <h3 className='aviso'>Geometry Dash DemonList</h3>
                        <p>Aunque aun esta en desarrollo en github, <u>pronto sera publico</u> y are un video tutorial al respecto.</p>
                        <a href='/proyectos/Demonlist' class='btn'>Ver mas <span class="material-symbols-outlined fixV owo">open_in_new</span></a>
                      </article>
                    </div>

                    <div className='tarjeta n3'>
                      <article>
                        <h3 className='aviso'>GODOT Geometry Dash</h3>
                        <p>Serie de tutoriales en mi <a href='https://www.youtube.com/@Cro128' target='_blank' rel="noreferrer">canal de youtube</a> sobre recrear Geometry Dash en godot engine, haz clic en ver mas para ver el repositorio publico en github!</p>
                        <a href='/proyectos/GodotGD' class='btn'>Ver mas <span class="material-symbols-outlined fixV owo">open_in_new</span></a>
                      </article>
                    </div>

                    <div className='tarjeta n4'>
                      <article>
                        <h3 className='aviso'>Mi primer juego</h3>
                        <p>Juego hecho en el 2017, fue el primero "terminado" que hice, es muy malo pero lo conservo por los recuerdos</p>
                        <a href='/proyectos/PrimerJuego' class='btn'>Ver mas <span class="material-symbols-outlined fixV owo">open_in_new</span></a>
                      </article>
                    </div>

                  </div>
              </section>

              <section className='exp'>
                  <center><h3>Video reciente:</h3></center>
                  <iframe title='Mi video mas reciente de youtube' alt='Mi Video mas reciente de Youtube' className='video' src='https://www.youtube.com/embed/aK2uTiMSTJY?si=0wV9ctczOXyRY6DM' allow="accelerometer; autoplay; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                  

                  <h3>Mis redes sociales</h3>

                  <div className='grid'>
                    <a href='https://www.youtube.com/@Cro128' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Youtube logo' src='https://cdn-1.webcatalog.io/catalog/youtube/youtube-icon-filled-256.png?v=1712225043901' />
                      <h4>Youtube</h4>
                    </a>

                    <a href='https://x.com/Cro_128' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Twitter/X logo' src='https://img.freepik.com/vector-gratis/twitter-nuevo-logotipo-2023-x-vector-fondo-blanco_1017-45422.jpg?size=338&ext=jpg&ga=GA1.1.1687694167.1714780800&semt=ais' />
                      <h4>Twitter/X</h4>
                    </a>

                    <a href='https://discord.gg/US3JmB4RPH' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Github logo' src='https://assets.mofoprod.net/network/images/discord.original.jpg' />
                      <h4>Discord</h4>
                    </a>

                    <a href='https://github.com/cro128' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Github logo' src='https://cdn.icon-icons.com/icons2/2429/PNG/512/github_logo_icon_147285.png' />
                      <h4>Github</h4>
                    </a>

                    <a href='https://cro128.itch.io/' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Itchio Logo' src='https://cdn-1.webcatalog.io/catalog/itch-io/itch-io-icon-filled-256.png?v=1675597663561' />
                      <h4>Itchio</h4>
                    </a>

                    <a href='https://www.fiverr.com/cro128' target='_blank' rel="noreferrer" className='red'>
                      <img alt='Fiverr logo' src='https://cdn-1.webcatalog.io/catalog/fiverr/fiverr-icon-filled-256.png?v=1675614010794' />
                      <h4>Fiverr</h4>
                    </a>
                  </div>

                  
              </section>

          </div>
        </article>
      </div>
    </>
  )
}
